var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNavigator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mini_Navigator",
    d: "M8.72,16.72a8,8,0,1,1,8-8,8.009,8.009,0,0,1-8,8Zm0-14.667A6.667,6.667,0,1,0,15.387,8.72,6.674,6.674,0,0,0,8.72,2.053Zm.015,1.083S6.387,7.16,6.387,8.387v.667c0,1.226,2.355,5.333,2.355,5.333s2.311-4.022,2.311-5.248V8.385c0-1.226-2.318-5.248-2.318-5.248ZM8.72,10.053A1.333,1.333,0,1,1,10.053,8.72,1.333,1.333,0,0,1,8.72,10.053Z",
    transform: "translate(-0.72 -0.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigator);
export default __webpack_public_path__ + "static/media/IconNavigator.51875871.svg";
export { ForwardRef as ReactComponent };